import React, { useEffect, useState } from "react"
import classNames from "classnames"
import { DesktopDatePicker } from "@mui/x-date-pickers"
import { TextField } from "@mui/material"

import { getNextDays } from "../lib"

const isBold = (date, newDate) => {
  return newDate && date !== newDate
}

export const ValidFromDatePicker = ({
  value,
  name,
  style = {},
  onChange,
  className = "date-time-picker",
  invalid,
  ...rest
}) => {
  const [date, setDate] = useState(value)
  const [error, setError] = useState(false)

  useEffect(() => {
    setError(false)
    setDate(
      value?.valid_from ??
        value?.new_affiliate_price_valid_from ??
        value?.affiliate_price_valid_from ??
        value?.new_purchase_price_valid_from ??
        value?.purchase_price_valid_from ??
        null
    )
  }, [
    value?.valid_from,
    value?.new_affiliate_price_valid_from,
    value?.affiliate_price_valid_from,
    value?.new_purchase_price_valid_from,
    value?.purchase_price_valid_from
  ])

  const handleChange = (value) => {
    if (value?.toDate() > new Date()) {
      setError(false)
    } else {
      setError(true)
    }
    setDate(value)
    onChange(value)
  }

  const hasError = !!error || invalid

  return (
    <div
      className={classNames(className, {
        error: hasError,
        "bold-price":
          !!isBold(
            value?.affiliate_price_valid_from,
            value?.new_affiliate_price_valid_from
          ) ||
          !!isBold(
            value?.purchase_price_valid_from,
            value?.new_purchase_price_valid_from
          )
      })}
      style={style}
    >
      <DesktopDatePicker
        closeOnSelect
        disablePast
        minDate={getNextDays()}
        value={date}
        inputFormat="DD.MM.YYYY"
        onChange={handleChange}
        PopperProps={{ id: "date-picker" }}
        renderInput={(props) => {
          return (
            <TextField
              fullWidth
              variant="standard"
              name={name}
              {...props}
              inputProps={{
                ...props.inputProps,
                readOnly: true,
                placeholder: "DD.MM.YYYY"
              }}
              error={hasError}
            />
          )
        }}
        {...rest}
      />
    </div>
  )
}
